export default {
  getDataLead: state => state.dataLead,
}
